import { useTheme } from '@/contexts/ThemeContext'
import './Trapezoid.css'

import type { ReactNode } from 'react'

export type TrapezoidVariant = 'both' | 'left' | 'right' | 'parallelogram' | 'none'

interface TrapezoidProps {
  children?: ReactNode
  style?: React.CSSProperties
  variant?: TrapezoidVariant
}

const Trapezoid = ({ children, style, variant = 'both' }: TrapezoidProps) => {
  const theme = useTheme()

  return (
    <div
      className={`trapezoid trapezoid-${variant}`}
      // @ts-expect-error unknown CSS prop
      style={{ height: theme.baseHeight, '--p': `calc(${theme.baseHeight} * 0.6)`, ...style }}
    >
      {children}
    </div>
  )
}

export default Trapezoid
